// @flow

import React from 'react';
import { Image, Nav, NavItem } from 'react-bootstrap/lib';
import { IndexLinkContainer } from 'react-router-bootstrap';
import styler from 'react-styling';
import logo from '../../img/symfoni_logo.png';

const style = styler `
  Navbar
    position: fixed
    left: 0
    height: 100%
    background-color: #0A152D
    padding: 15px 0 0 0
    min-width: 180px
    z-index: 1000
  Logo
    max-width: 100px
  Brand
    padding: 5px 0 26px 20px
  MenuIcon
    width: 18px
    font-size: 16px
    text-align: center
    margin-right: 10px
`;

type Props = {
  languagedata: Object,
  me: Object,
};

const NavLeftSide = (props: Props) => {
  const lang = props.languagedata;
  return (
    <div style={style.Navbar}>
      <div style={style.Brand}>
        <Image style={style.Logo} src={logo} alt="Logo" />
      </div>
      <Nav bsStyle="pills" stacked activeKey={1}>
        <IndexLinkContainer to="/contacts" activeHref="active" className="menuelement">
          <NavItem eventKey={1}><i className="fa fa-address-book-o" style={style.MenuIcon} /> {lang.people}</NavItem>
        </IndexLinkContainer>
        <IndexLinkContainer to="/contacts/meetingrooms" activeHref="active" className="menuelement">
          <NavItem eventKey={2}><i className="fa fa-comments-o" style={style.MenuIcon} /> {lang.meeting_rooms}</NavItem>
        </IndexLinkContainer>
        <IndexLinkContainer to="/contacts/resources" activeHref="active" className="menuelement">
          <NavItem eventKey={2}><i className="fa fa-car" style={style.MenuIcon} /> {lang.other_resources}</NavItem>
        </IndexLinkContainer>
        <IndexLinkContainer to="/favourites" activeHref="active" className="menuelement">
          <NavItem eventKey={3}><i className="fa fa-star" style={style.MenuIcon} /> {lang.favorites}</NavItem>
        </IndexLinkContainer>
        <IndexLinkContainer to={`/scheduler?email=${props.me.email}`} activeHref="active" className="menuelement">
          <NavItem eventKey={4}><i className="fa fa-clock-o" style={style.MenuIcon} /> {lang.scheduler}</NavItem>
        </IndexLinkContainer>
        <IndexLinkContainer to={`/calendar?email=${props.me.email}`} activeHref="active" className="menuelement">
          <NavItem eventKey={5}><i className="fa fa-clock-o" style={style.MenuIcon} /> {lang.scheduler}</NavItem>
        </IndexLinkContainer>
      </Nav>
    </div>
  );
};

export default NavLeftSide;




// WEBPACK FOOTER //
// ./src/js/Components/NavSideLeft.js